// Isolated in its own module so Jest can mock it via moduleNameMapper (see
// config-overrides.js) instead of parsing `import.meta`, which Jest's Babel
// transform does not support. Webpack 5 resolves this `new URL(...)` call as
// a static asset and emits the worker as its own chunk at build time.
//
// Uses the legacy build (not build/pdf.worker.min.mjs) because the non-legacy
// build relies on Promise.withResolvers/structuredClone, which require
// Chrome/Edge 119+, Firefox 121+, Safari 17.4+ — newer than the browsers our
// production browserslist (">0.2%, not dead") still targets (e.g. Safari
// 16.x, older iOS). Since this file is emitted as a raw asset, Babel never
// transpiles it, so unsupported browsers would otherwise get a TypeError as
// soon as a PDF loads. config-overrides.js aliases `pdfjs-dist` to the same
// legacy build for the main thread so both stay in sync.
const pdfWorkerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString();

export default pdfWorkerSrc;
